/* eslint-disable import/prefer-default-export */
export const subscriptionStatusOptions = {
  active: ['active', 'subscription.activated'],
  canceled: ['canceled', 'subscription.canceled'],
  past_due: ['past_due', 'subscription.past_due'],
  paused: ['paused', 'subscription.paused'],
  trialing: ['trialing', 'subscription.trialing'],
};
